import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { hideWhenReadOnlyRule } from '../commonRules';
export const ImportDataButton = {
    key: 'import',
    buttonStyle: 'default-1',
    icon: faFileImport,
    section: 'middle',
    prio: 8,
    text: 'Importera data',
    defaultRules: [
        hideWhenReadOnlyRule,
        {
            id: 'hideIfNotReviewer',
            description: 'Knappen är dold om användaren inte är monitor.',
            evaluateState: (row, inca)=>{
                if (!inca.user.role.isReviewer) {
                    return {
                        state: 'Hidden'
                    };
                }
                return {
                    state: 'Visible'
                };
            }
        }
    ],
    onClick: async (row, inca)=>{
        inca.errand.importData();
    }
};
